module.exports = __webpack_public_path__ + "static/media/188.95a03cf9.jpg";